import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgShare = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 33,
	viewBox: "0 0 32 33",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_3192_8300)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M7.67727 32.894C6.91447 32.894 6.27756 32.6385 5.76653 32.1275C5.25551 31.6165 5 30.9796 5 30.2168V14.0255C5 13.2627 5.25551 12.6258 5.76653 12.1148C6.27756 11.6037 6.91447 11.3482 7.67727 11.3482H11.1833V13.0056H7.67727C7.42231 13.0056 7.18858 13.1118 6.97608 13.3243C6.76361 13.5368 6.65737 13.7705 6.65737 14.0255V30.2168C6.65737 30.4717 6.76361 30.7055 6.97608 30.918C7.18858 31.1304 7.42231 31.2367 7.67727 31.2367H25.5259C25.7809 31.2367 26.0146 31.1304 26.2271 30.918C26.4396 30.7055 26.5458 30.4717 26.5458 30.2168V14.0255C26.5458 13.7705 26.4396 13.5368 26.2271 13.3243C26.0146 13.1118 25.7809 13.0056 25.5259 13.0056H22.0199V11.3482H25.5259C26.2887 11.3482 26.9256 11.6037 27.4366 12.1148C27.9477 12.6258 28.2032 13.2627 28.2032 14.0255V30.2168C28.2032 30.9796 27.9477 31.6165 27.4366 32.1275C26.9256 32.6385 26.2887 32.894 25.5259 32.894H7.67727ZM15.7729 22.1211V4.07814L12.2924 7.55858L11.1195 6.37612L16.6016 0.894043L22.0837 6.37612L20.9108 7.55858L17.4303 4.07814V22.1211H15.7729Z",
			fill: "currentColor"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_3192_8300",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 32,
			height: 32,
			fill: "none",
			transform: "translate(0 0.894043)"
		})
	}) })]
});
export default SvgShare;
